import { Typography, Box, Icon } from "@mui/material";
import { useTheme } from "@emotion/react";

const ActionOption = ({ id, title, subtitle, isSelected, onSelect, isPopular = false, isDefault = false, children }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        border: `${isPopular ? "4px" : "2px"} solid ${isSelected ? theme.palette.primary.main : isPopular ? theme.palette.primary.main : theme.palette.border.primary}`,
        ...(isDefault && !isSelected && !isPopular && {
          borderColor: theme.palette.primary.main,
          borderWidth: "2px",
        }),
        borderRadius: { xs: "12px", sm: "16px" },
        px: { xs: 2, sm: 3 },
        py: { xs: 2.5, sm: 4 },
        cursor: "pointer",
        boxSizing: "border-box",
        minHeight: { xs: "90px", sm: "120px" },
        backgroundColor: "white",
        transition: "all 0.2s ease-in-out",
        boxShadow: isSelected ? "0 4px 20px rgba(0, 0, 0, 0.1)" : "0 2px 8px rgba(0, 0, 0, 0.04)",
        "&:hover": {
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          transform: "translateY(-1px)",
        },
      }}
      onClick={() => onSelect(id)}
    >
      {/* Popular tag */}
      {isPopular && (
        <Box
          sx={{
            position: "absolute",
            top: -2,
            right: 20,
            background: theme.palette.primary.main,
            color: "white",
            px: 2.5,
            py: 0.8,
            borderRadius: "0 0 12px 12px",
            fontSize: "0.75rem",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            zIndex: 2,
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          }}
        >
          Popular
        </Box>
      )}
      <Box
        sx={{ 
          display: "flex", 
          gap: { xs: 1.5, sm: 2 }, 
          alignItems: "flex-start", 
          flex: 1,
          ...(isPopular && { pt: { xs: 1, sm: 1.5 } })
        }}
      >
        <Box
          sx={{
            minWidth: "24px",
            minHeight: "24px",
            mt: 0.5,
            border: `2px solid ${isSelected ? theme.palette.primary.main : theme.palette.border.primary}`,
            backgroundColor: isSelected ? theme.palette.primary.main : "transparent",
            borderRadius: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transition: "all 0.2s ease-in-out",
          }}
        >
          {isSelected && (
            <Box
              sx={{
                width: "8px",
                height: "8px",
                backgroundColor: "white",
                borderRadius: "100%",
              }}
            />
          )}
        </Box>
        <Box
          sx={{ display: "flex", flexDirection: "column", textAlign: "left", flex: 1 }}
        >
          <Typography
            variant={"h6"}
            sx={{ 
              fontWeight: (isPopular || isSelected) ? "800" : "600",
              fontSize: { xs: "1rem", sm: "1.125rem" },
              lineHeight: 1.3,
              mb: { xs: 0.5, sm: 1 },
              color: "text.primary",
              mt: 0.5
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant={"body2"}
              sx={{
                alignSelf: "flex-start",
                whiteSpace: "pre-line",
                color: "text.secondary",
                fontSize: { xs: "0.875rem", sm: "1rem" },
                lineHeight: 1.4,
                fontWeight: isSelected ? "500" : "400",
              }}
            >
              {subtitle}
            </Typography>
          )}
          {/* Render any additional content (like animations) */}
          {children && (
            <Box sx={{ mt: 2 }}>
              {children}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ActionOption;
